<template>
  <div>
    <v-card>
      <v-row class="pa-5">
        <v-col cols="12" class="float-right text-right">
          <v-tabs v-model="tab" show-arrows>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#InfoDetail">
              <h6>
                اطلاعات {{ merchantRolesIsSupplier ? 'کسب و کار' : 'خریدار' }}
              </h6>
            </v-tab>
            <v-tab href="#EditRequest" v-if="merchantIsApproved">
              <h6>سوابق درخواست ویرایش</h6>
            </v-tab>
            <v-tab href="#Message">
              <h6>پیام ها</h6>
            </v-tab>
            <v-tab href="#Event">
              <h6>رویداد ها</h6>
            </v-tab>
             <v-tab href="#Permit">
              <h6>  دسترسی به همکاران</h6>
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item :value="'InfoDetail'">
          <v-card-text flat>
            <Business-information
              v-if="authorize == 'merchant' || authorize == 'supplier'"
              ref="BusinessInformation"
            ></Business-information>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'EditRequest'" v-if="merchantIsApproved">
          <v-card-text flat>
            <merchant-history
              :merchantId="$store.getters.currentMerchant"
            ></merchant-history>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Message'">
          <v-card-text flat>
            <ThreadsList
              v-if="merchantId"
              @getConversationId="getConversationId"
              @closeThreadList="true"
              topic="Merchant"
              type="AdminMerchant"
              :objectId="merchantId"
              :key="key"
              :conversationId="
                businessInformationConversationList &&
                businessInformationConversationList.length
                  ? businessInformationConversationList[0].conversationId
                  : null
              "
              :recipientMerchantId="merchantId ? merchantId : null"
              :recipientUserId="null"
              :createdByMerchantId="merchantId"
              :isUserBase="false"
            >
            </ThreadsList>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Event'">
          <v-card-text flat>
            <BusinessInformationEvents
              :merchantId="$store.getters.currentMerchant"
            ></BusinessInformationEvents>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Permit'">
          <v-card-text flat>
            <BusinessInformationPermit
              :merchantId="$store.getters.currentMerchant"
              :ownerPhoneNumber="userPhone"
              :merchantIsApproved="merchantIsApproved"
            ></BusinessInformationPermit>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import ThreadsList from '@/components/core/conversation/components/ThreadsList.vue';
import Helper from '@/core/helpers';
import BusinessInformationConversationList from '../businessInformationConversation/components/BusinessInformationConversationList.vue';
const businessInformationConversationRepository = () =>
  RepoFactory.get('businessInformationConversation');
import BusinessInformation from '@/modules/businessInformation/components/BusinessInformation.vue';
import BusinessInformationEvents from '@/components/businessInformation/events/BusinessInformationEvents.vue';
import BusinessInformationPermit from '@/components/businessInformation/permit/BusinessInformationPermit.vue';
import roleMiddlewaresMixin from '@/core/mixins/roleMiddlewaresMixin';
import { mapGetters } from 'vuex';
import MerchantHistory from '@/components/businessInformation/merchantHistory/MerchantHistory.vue';
export default {
  data() {
    return {
      key: 0,
      businessInformationConversationList: null,
      userPhone:null,
    };
  },
  mixins: [roleMiddlewaresMixin],
  components: {
    ThreadsList,
    BusinessInformationConversationList,
    BusinessInformation,
    BusinessInformationEvents,
    MerchantHistory,
    BusinessInformationPermit
  },
  computed: {
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    ...mapGetters(['authorize', 'currentMerchant', 'contentBaseUrl']),
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
    merchantIsApproved() {
      return this.userBusinessInformation?.status == 'Approved' ? true : false;
    },
    merchantRolesIsSupplier() {
      if (this.userBusinessInformation)
        return this.userBusinessInformation?.isSupplier;
      else {
        return this.merchantInformation?.isSupplier;
      }
    },
    userBusinessInformation() {
      if (
        this.authorize == 'merchant' &&
        !this.$store.getters.userDetails.roles.includes('supplier')
      ) {
        return this.$store.getters.userBusinessInformation;
      } else {
        if (this.currentMerchant) {
          return this.$store.getters.merchantInformation;
        }

      }
    },
  },
  watch: {
    merchantId() {
      if (this.merchantId) {
        this.getBusinessInformationConversaion();
      }
    },
  },
  methods: {
    getConversationId(val) {
      this.businessInformationConversationList[0].conversationId = val;
      this.key += 1;
    },
    getBusinessInformationConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.merchantId,
        type: 'AdminMerchant',
        topic: 'Merchant',
        PageNumber: 1,
        ItemsPerPage: 5,
      };
      businessInformationConversationRepository()
        .getConversation(
          this.contentBaseUrl,
          { MerchantId: this.merchantId },
          param
        )
        .then((res) => {
          this.businessInformationConversationList = res.data.list;
        })
        .catch((err) => {
          console.log('err', err);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
